import { defer, type Subscription } from "rxjs";
import type { SparxListResponse } from "@exagens/behavioral-insight-console-client";
import { displayAllInteraction } from "@/services/internalSparxEditor.service";
import { sparxsEditorCatalogReplaced } from "@/features/sparxsEditor/store/domainActions";
import { catalogFingerprint } from "@/features/sparxsEditor/lib/catalog/catalogFingerprint";
import type { AppDispatch, RootState } from "@/store/app/storeTypes";
import { sparxsEditorEntryBlocked } from "@/store/sparxsCatalog/editorEntryBlockedSlice";

const isAbortLikeError = (error: unknown): boolean => {
  if (error instanceof Error && error.name === "AbortError") {
    return true;
  }
  return (
    typeof DOMException !== "undefined" &&
    error instanceof DOMException &&
    error.name === "AbortError"
  );
};

export type EditorCatalogListSubscriptionParams = {
  getState: () => RootState;
  dispatch: AppDispatch;
  onError?: () => void;
};

export const subscribeEditorCatalogList = (
  params: EditorCatalogListSubscriptionParams,
): Subscription =>
  defer(() => displayAllInteraction()).subscribe({
    next: (result: SparxListResponse) => {
      const prev = params.getState().editor.sparxsList;
      const nextFp = catalogFingerprint(result.files, result.excludedFiles);
      const prevFp = catalogFingerprint(prev.data, prev.excludedData);
      if (result.files.length === 0 && prev.data.length > 0) {
        return;
      }
      if (nextFp === prevFp) {
        return;
      }
      params.dispatch(sparxsEditorCatalogReplaced(result));
    },
    error: (error: unknown) => {
      if (isAbortLikeError(error)) {
        return;
      }
      console.error("Editor catalog list failed", error);
      params.dispatch(sparxsEditorEntryBlocked({ kind: "catalog_list" }));
      params.onError?.();
    },
  });
